import React, { Component } from 'react';
import propTypes from 'prop-types';

import classNames from 'classnames';
import { get } from 'lodash';

// constants
import { scriptTypes } from 'constants/scripts';

import { Card } from '@tcc/crate';
import ManualFertilityPlanFormInputs from 'planting-plan-form/ManualFertilityPlanFormInputs';
import ManualPlantingPlanFormInputs from 'planting-plan-form/ManualPlantingPlanFormInputs';
import DefaultScriptName from 'planting-plan-form/DefaultScriptName';
import ManualCropProtectionInputsConnected from './CropProtection/ManualCropProtectionInputs';

const baseString = 'vra-planting-plan-form';
class ManualPlantingPlanForm extends Component {

  componentDidMount() {
    this.props.onMount();
  }

  render() {
    const {
      fertilityActivities,
      fertilityActivityCategories,
      hasSubstanceType,
      isAppMode,
      isPlantingPlanLocked,
      maxDate,
      minDate,
      nitrapyrin,
      onChangeNitrapyrin,
      onChangePlantingFertilizerApplication,
      onChangeScriptName,
      onSelectDate,
      onSelectFertilityActivityCategory,
      onSelectIncorporationMethod,
      onSelectSubstanceType,
      plantingPlanParams,
      scriptId,
      scriptType,
      showScriptNameInput,
      substanceTypeIsNitrogen,
      substanceTypes,
      validationResult
    } = this.props;

    const classString = classNames({
      [`${baseString}`]: true,
      [`${baseString}--${scriptType}`]: !!scriptType
    });
    let inputs;

    switch (scriptType) {
      case scriptTypes.FERTILITY:
        inputs = (
          <ManualFertilityPlanFormInputs
            disabled={isPlantingPlanLocked}
            fertilityActivities={fertilityActivities}
            fertilityActivityCategories={fertilityActivityCategories}
            hasSubstanceType={hasSubstanceType}
            isAppMode={isAppMode}
            maxDate={maxDate}
            minDate={minDate}
            onChangeNitrapyrin={(e) => onChangeNitrapyrin(e, scriptId, nitrapyrin)}
            onChangePlantingFertilizerApplication={onChangePlantingFertilizerApplication}
            onSelectDate={onSelectDate}
            onSelectFertilityActivityCategory={onSelectFertilityActivityCategory}
            onSelectSubstanceType={onSelectSubstanceType}
            plantingPlanParams={plantingPlanParams}
            substanceTypeIsNitrogen={substanceTypeIsNitrogen}
            substanceTypes={substanceTypes}
            validationResult={validationResult}
          />
        );
        break;
      case scriptTypes.PLANTING:
        inputs = (
          <ManualPlantingPlanFormInputs
            disabled={isPlantingPlanLocked}
            isAppMode={isAppMode}
            maxDate={maxDate}
            minDate={minDate}
            onChangePlantingFertilizerApplication={onChangePlantingFertilizerApplication}
            onSelectDate={onSelectDate}
            plantingPlanParams={plantingPlanParams}
            validationResult={validationResult}
          />
        );
        break;
      case scriptTypes.APPLICATION:
        inputs = (
          <ManualCropProtectionInputsConnected
            disabled={isPlantingPlanLocked}
            isAppMode={isAppMode}
            maxDate={maxDate}
            minDate={minDate}
            onSelectDate={onSelectDate}
            onSelectIncorporationMethod={onSelectIncorporationMethod}
            plantingPlanParams={plantingPlanParams}
            validationResult={validationResult}
          />
        );
        break;
      case scriptTypes.EXPERIMENT:
        inputs = (
          <ManualCropProtectionInputsConnected
            disabled={isPlantingPlanLocked}
            isAppMode={isAppMode}
            maxDate={maxDate}
            minDate={minDate}
            onSelectDate={onSelectDate}
            onSelectIncorporationMethod={onSelectIncorporationMethod}
            plantingPlanParams={plantingPlanParams}
            validationResult={validationResult}
          />
        );
        break;
      default:
    }
    return (
      <Card className={classString}>
        <form data-test-id={'manual-planting-plan'}>
          {inputs}
          <DefaultScriptName
            disabled={isPlantingPlanLocked}
            isVisible={showScriptNameInput}
            onChange={onChangeScriptName}
            plantingPlanParams={plantingPlanParams}
            validationResult={get(validationResult, 'resultsByKey.scriptName')}
          />
        </form>
      </Card>
    );
  }
}
ManualPlantingPlanForm.propTypes = {
  fertilityActivities: propTypes.object.isRequired,
  fertilityActivityCategories: propTypes.array.isRequired,
  hasSubstanceType: propTypes.bool.isRequired,
  isAppMode: propTypes.bool.isRequired,
  isPlantingPlanLocked: propTypes.bool,
  maxDate: propTypes.string.isRequired,
  minDate: propTypes.string.isRequired,
  nitrapyrin: propTypes.object,
  onChangeNitrapyrin: propTypes.func.isRequired,
  onChangePlantingFertilizerApplication: propTypes.func.isRequired,
  onChangeScriptName: propTypes.func.isRequired,
  onMount: propTypes.func.isRequired,
  onSelectDate: propTypes.func.isRequired,
  onSelectFertilityActivityCategory: propTypes.func.isRequired,
  onSelectIncorporationMethod: propTypes.func.isRequired,
  onSelectSubstanceType: propTypes.func.isRequired,
  plantingPlanParams: propTypes.object.isRequired,
  scriptId: propTypes.string,
  scriptType: propTypes.string.isRequired,
  scriptsForPrepopulation: propTypes.object,
  showScriptNameInput: propTypes.bool.isRequired,
  substanceTypeIsNitrogen: propTypes.bool.isRequired,
  substanceTypes: propTypes.object.isRequired,
  validationResult: propTypes.object // null is passed when there are no validation errors
};

export default ManualPlantingPlanForm;
